import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import dataModel from '../../models/DataModel';
import TaskCardInner from '../../components/TaskCardInner';
import CopyTaskPopout from '../../components/CopyTaskPopout';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import './TaskMenuPopup.scss';

export default class TaskMenuPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      displayCopyPopout: false,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.task) {
      this.setState({ task: this.props.task });
    }
    dataModel.setDisableAppBackground(true);
  }

  componentWillUnmount() {
    dataModel.setDisableAppBackground(false);
  }

  doDeleteTask() {
    const { task } = this.state;
    dataModel.tasksDAO.deleteTask(task.id).then(() => {
      this.props.handleClosePopup();
      if (this.props.handleTaskDeleted) {
        this.props.handleTaskDeleted(this.state.task);
      }
    });
  }

  handleTaskDelete(e) {
    e.stopPropagation();

    const message = 'Are you sure you want to delete ' + this.state.task.name.toUpperCase() + '? This action cannot be undone.';

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.cancel.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        this.analyticsLogger.logTaskAdminEvent(this.props.isFromTemplate ? 'PTQuickActionsTaskDeleted' : 'ProjectQuickActionsTaskDeleted');
        this.doDeleteTask();
      },
      handleOwnerCancel: () => {
        this.props.handleClosePopup();
      },
    });
  }

  handleClick(event) {
    if (!this.state.displayCopyPopout) {
      event.stopPropagation();
      this.props.handleClosePopup();
    }
  }

  handleDisplayCopyPopout(e) {
    if (e) e.stopPropagation();

    const { displayCopyPopout } = this.state;
    if (displayCopyPopout) {
      this.props.handleClosePopup();
    }
    this.setState({ displayCopyPopout: !displayCopyPopout });
  }

  render() {
    if (!this.state.task) {
      return null;
    }

    //255 is the width of the copy task popout. Would be better to use ref but cannot with the way we inject this component into the DOM
    let left;
    let leftClassName = '';
    if ((this.props.cardRect.left + this.props.cardRect.width + 255) > window.innerWidth) {
      left = -96;
      leftClassName = ' menu-item--left';
    }

    let menuPopup = (
      <div className="menu-popout" style={{ left: left }}>
        <div className={'menu-item' + leftClassName} onClick={this.handleDisplayCopyPopout}>Copy</div>
        <div className={'menu-item' + leftClassName} onClick={this.handleTaskDelete}>Delete</div>
      </div>
    );

    return (
      <div className={'task-menu-popup'} onClick={this.handleClick}>
        <div className={'task-menu-overlay'}
          style={
            { left: this.props.cardRect.x - 2, top: this.props.cardRect.y - 2, width: this.props.cardRect.width, height: this.props.cardRect.height }}
          ref={(element) => this.taskElement = element}>
          <div className="menu-open-indicator" />
          { !this.state.displayCopyPopout && menuPopup }
          <TaskCardInner task={this.state.task} bulkAssign={this.props.bulkAssign} selectDisabled={this.props.selectDisabled}/>
          <CopyTaskPopout 
            task={this.state.task} 
            handleClosePopup={this.handleDisplayCopyPopout}
            displayCopyPopout={this.state.displayCopyPopout}
            handleAddCopiedTask={this.props.handleAddCopiedTask}
            currentUser={this.props.currentUser}
            isFromTemplate={this.props.isFromTemplate}
          />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/TaskMenuPopup/index.js